import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { IGNORE_ERRORS } from '@src/slide/infrastructure/module/dependent/report/js-error/constant';
import { TDWOperationType, TDWModuleType, TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { statusReport007 } from '@src/slide/infrastructure/module/dependent/report/real-time-report/real-time';
import {
    Reporter007,
    Reporter007ActionType,
} from '@src/slide/infrastructure/module/dependent/report/real-time-report/constant';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import ua from '@tencent/docs-user-agent';
import { reportErrorToTam, LogType } from './tam-report';

/**
 * slide js-error tdw统计模块
 * 用作汇总异常，生成报表
 * 细节排查在sentry/aegis
 */

// 是否已上报过（目前的策略是一个pv只上报一次）
let reportEd = false;

// eslint-disable-next-line complexity
const isIgnoreError = (msg): boolean => {
    // 无内容异常 - 忽略
    if (!msg) {
        return true;
    }

    // 已知的可忽略异常 - 忽略
    if (IGNORE_ERRORS.some(errStr => msg.match(errStr))) {
        return true;
    }

    // ios16的qq浏览器存在此报错，非正常入口，可忽略（后期浏览器兼容后可移除）
    // update-客户端在3.8.0新增了一个qq浏览器的hook导致3.8.0及以上版本的客户端有同样的问题，忽略
    if (browser.isIOS
        && (ua.isQQBrowser || ua.isTencentDocsAppVersionAboveOrEqual('3.8.0'))
        && msg.match(/NetworkError: Load failed/)) {
        return true;
    }

    // QQ8.9.70 - 8.9.75之间的版本 webview注入的脚本有bug，产生的Script error可忽略
    if (browser.isIOS && (ua.isQQ || ua.isQQMiniProgram)) {
        if (msg.match(/Script error./)) {
            tdw({
                opername: TDWOperationType.PPT_QUALITY,
                module: TDWModuleType.PERFORMANCE_DETAIL,
                action: TDWActionType.SLIDE_JS_ERROR_COLLECTION,
                ver6: JSON.stringify({
                    versionSplit: ua.getQQVersion()?.split?.('.') || [],
                    isQQ: ua.isQQ,
                    isQQMiniProgram: ua.isQQMiniProgram,
                }),
            });
            return true;
        }
    }

    // safari下的 ResizeObserver loop limit exceeded 会以Script error形式上报，所以将此环境的忽略
    if (browser.isSafari && msg.match(/Script error./)) {
        return true;
    }

    return false;
};

// tdw数据上报
const tdwReport = (event) => {
    const msg = event?.message || event?.reason?.message;

    // 已上报过一次 - 忽略
    if (reportEd) {
        return;
    }
    // 非生产环境异常 - 忽略
    if (!ENV.IS_RELEASE) {
        return;
    }

    // 部分error已知，直接忽略
    if (isIgnoreError(msg)) {
        return;
    }

    // 上报
    const errorInfo = { type: event.type, msg, ua: window?.navigator?.userAgent };
    reportEd = true;
    tdw({
        opername: TDWOperationType.PPT_QUALITY,
        module: TDWModuleType.PERFORMANCE_DETAIL,
        action: event.type === 'unhandledrejection' ? TDWActionType.SLIDE_JS_ERROR_PROMISE : TDWActionType.SLIDE_JS_ERROR_NORMAL,
        ver6: JSON.stringify(errorInfo),
    });
    statusReport007(Reporter007ActionType.SLIDE_JS_ERROR, Reporter007.ERROR);
};

// 普通的js-error捕获
const windowErrorCatch = () => {
    window.addEventListener('error', (event) => {
        tdwReport(event);
        reportErrorToTam(event, LogType.ERROR);
    });
};

// promise未主动catch捕获
const promiseErrorCatch = () => {
    window.addEventListener('unhandledrejection', (event) => {
        tdwReport(event);
        reportErrorToTam(event, LogType.PROMISE_ERROR);
    });
};

(() => {
    if (!window) {
        return;
    }
    windowErrorCatch();
    promiseErrorCatch();
})();


